class SendToSunrooms {
	constructor($scope, config) {
		this.config = config;
		this.$scope = $scope;
		this.init();
	}

	init() {
		this.$scope.on('click', this.config.sendToSunrooms, this.sendToSunrooms.bind(this));
	}

	sendToSunrooms(event) {
		event.stopPropagation();
		event.preventDefault();
		let $button = $(event.currentTarget);
		let order = $button.closest(`${this.config.details}, ${this.config.toggle}`).data('order');
		let $main = $button.closest(this.config.scope).find(`${this.config.toggle}[data-order="${order}"]`);
		let $details = $button.closest(this.config.scope).find(`${this.config.details}[data-order="${order}"]`);

		showLoader();
		$.ajax({
			url: window.location.pathname,
			method: 'post',
			data: {
				orderId: $button.data('order'),
				action: 'send_to_sunrooms'
			},
			success: this.onSuccess.bind(this, $main, $details),
			error: this.onError.bind(this, $main, $details),
		}).always(() => {
			hideLoader();
		});
	}

	onSuccess($main, $details, response) {
		location.reload();
	}

	onError($main, $details, response) {
		alert(response.responseJSON.message);
	}
}

export default SendToSunrooms;